// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table thead tr td[data-v-c06bd1c2] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\ntable tbody tr td[data-v-c06bd1c2] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
